'use client';

import Decimal from 'decimal.js';
import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { CentText } from '@/lib/components/Text/CentText';
import { Text } from '@/lib/ui-kit/text';
import { cn } from '@/lib/ui-kit/utils';

type OrderBookSpreadProps = ComponentProps<'div'> & {
  minAsk: Decimal | null;
  maxBid: Decimal | null;
  lastPrice?: Decimal | null;
};

export const OrderBookSpread = ({
  minAsk,
  maxBid,
  lastPrice,
  className,
  ...props
}: OrderBookSpreadProps) => {
  const t = useTranslations('orderBook');
  // Calculate spread only if both values are available
  const spread = minAsk && maxBid ? minAsk.minus(maxBid) : null;

  return (
    <div
      key={'spread'}
      className={cn(
        `border-y border-v2-border sticky bottom-0 top-0 z-10 flex h-9 w-full shrink-0 flex-row items-center gap-3 bg-v2-surface-primary px-3
        text-[10px] leading-[1.5] text-v2-text-secondary md:px-4`,
        className,
      )}
      {...props}
    >
      <div className="h-full min-w-12 flex-1 whitespace-pre text-end" />
      <Text className="min-w-12 flex-1 whitespace-pre text-end">
        {t('spread')} {spread ? <CentText value={spread} /> : '—'}
      </Text>

      <div className="h-full min-w-12 flex-1 whitespace-pre text-end" />
      <Text className="min-w-12 flex-1 text-end">
        {t('last')} {lastPrice ? <CentText value={lastPrice} /> : '—'}
      </Text>
    </div>
  );
};
